import React from 'react';
import { Tag } from 'antd';

// Paycor statuses that mean the person is still employed. Matches the set
// adherence.py filters on.
const STILL_EMPLOYED = new Set(['active', 'leavewithpay', 'leavewithoutpay']);

/**
 * Employment state for someone on a benefits bill.
 *
 * Renders NOTHING while they are still employed. The column exists to find
 * people who left but are still being charged, and a grey "Active" on every
 * row buries exactly the rows worth seeing. Silence is the common case; a tag
 * means look here.
 *
 * Nothing is rendered when there is no Paycor record either -- an unlinked
 * member or a user with no Payroll_ID is a gap in the join, not a departure,
 * and labelling it "Unknown" would compete with the real signal.
 */
export default function PaycorState({ status, termDate }) {
  if (!status && !termDate) return null;

  const key = (status || '').toLowerCase().replace(/[^a-z]/g, '');
  if (!termDate && STILL_EMPLOYED.has(key)) return null;

  return (
    <div style={{ fontSize: 11, marginTop: 2 }}>
      <Tag color="red" style={{ margin: 0 }}>
        {status || 'No longer employed'}{termDate ? ` ${termDate}` : ''}
      </Tag>
    </div>
  );
}
